import { Button } from '@repo/design-system/components/ds/button';
import { toast } from '@repo/design-system/components/ui/toaster';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { mapsApi } from '@repo/store/maps/api/mapsApi';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectIsMapEditor } from '@repo/store/maps/slices/auth';
import { selectExternalMapId, selectIsInCreatorMode, toggleCreatorMode, updateMapData } from '@repo/store/maps/slices/mapData';
import { getGameMap } from '@repo/wemod-api-client/maps-api-client';
import { useCallback, useState } from 'react';
import { getAuthTokenFromCookie } from '../utils/auth-cookie';
export const DebugModeToggle = () => {
  const dispatch = useAppDispatch();
  const {
    t
  } = useT(['common', 'game_map']);
  const isMapEditor = useAppSelector(selectIsMapEditor);
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  const externalMapId = useAppSelector(selectExternalMapId);
  const [isRefetching, setIsRefetching] = useState(false);

  // Get the current locale from i18n
  const locale = typeof window !== 'undefined' ? window.location.pathname.split('/')[1] || 'en-US' : 'en-US';
  const handleToggleCreatorMode = useCallback(async () => {
    if (isRefetching || !externalMapId) return; // Prevent multiple simultaneous requests

    setIsRefetching(true);
    try {
      const newCreatorMode = !isInCreatorMode;
      const enableDebug = newCreatorMode;
      dispatch(toggleCreatorMode());

      // Refetch with debug based on creator mode state (no route changes)
      const token = enableDebug ? getAuthTokenFromCookie() : undefined;
      const newMapData = await getGameMap(externalMapId, locale, enableDebug ? {
        debug: true,
        token
      } : undefined);
      dispatch(updateMapData(newMapData));
      dispatch(mapsApi.util.invalidateTags([{
        type: 'MapData',
        id: externalMapId
      }]));
      setIsRefetching(false);
      return;
    } catch {
      dispatch(toggleCreatorMode());
      setIsRefetching(false);
      toast({
        title: t($ => $.creator_mode_refetch_error, {
          ns: 'game_map'
        }),
        description: t($_0 => $_0.creator_mode_refetch_description, {
          ns: 'game_map'
        }),
        variant: 'error'
      });
    }
  }, [isRefetching, externalMapId, isInCreatorMode, dispatch, locale, t]);
  if (!isMapEditor) {
    return null;
  }
  return <div className={css({
    display: 'flex',
    justifyContent: 'center',
    width: 'full',
    paddingBottom: '8'
  })}>
            <Button onClick={handleToggleCreatorMode} variant={isInCreatorMode ? 'filled' : 'ghost'} color={isInCreatorMode ? 'warning' : 'primary'} size="sm" radius="rounded" fullWidth disabled={isRefetching}>
                <Type as="span" variant="body-xs">
                    {isRefetching ? t($_1 => $_1.loading) : isInCreatorMode ? t($_2 => $_2.exitCreatorMode, {
          ns: 'game_map'
        }) : t($_3 => $_3.enterCreatorMode, {
          ns: 'game_map'
        })}
                </Type>
            </Button>
        </div>;
};